import { render, staticRenderFns } from "./marketingCourse.vue?vue&type=template&id=ba7b8c8c&scoped=true"
import script from "./marketingCourse.vue?vue&type=script&lang=js"
export * from "./marketingCourse.vue?vue&type=script&lang=js"
import style0 from "./marketingCourse.vue?vue&type=style&index=0&id=ba7b8c8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7b8c8c",
  null
  
)

export default component.exports